import apiClient from '../apiClient';

// 요청 타입 정의
export type ReqGetPopup = {
  lastId?: number;
  sizeType: 'WEB' | 'MOBILE';
};

export interface PopUpContent {
  id: number;
  title: string;
  linkUrl: string;
  imageUrl: string;
  orderNumber: number;
  startDate: string;
  endDate: string;
  createdAt: string;
  updatedAt: string;
  itemContainerId: number;
  platformType: string;
}

export type ResGetPopup = SlotPaginationResponse<PopUpContent>;

// API 호출 함수
const getPopup = async ({ lastId, sizeType }: ReqGetPopup): Promise<ResGetPopup> => {
  // URLSearchParams를 사용하여 쿼리 문자열 생성
  const params = new URLSearchParams();
  if (lastId !== undefined) {
    params.append('lastId', lastId.toString());
  }
  params.append('sizeType', sizeType);
  params.append('platformType', 'GROUND');

  // API 호출
  const { data } = await apiClient.get<ResGetPopup>(`/app/pop-ups?${params.toString()}`);

  return data;
};

export default getPopup;
